module.exports = __webpack_public_path__ + "static/media/img5.fe98b028.jpg";